var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-row',_vm._l((_vm.filteredBinders),function(binder){return _c('v-col',{key:binder.binderId,attrs:{"cols":"12","sm":"6","lg":"4"}},[_c('binder',{attrs:{"binder-data":binder}})],1)}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }